<template>
  <div id="download">
      <TemplateLayout>
       <!-- Outer Row -->
        <div class="row justify-content-center">

            <div class="col-xl-12 col-lg-12 col-md-12">

                <div class="section-get-started card o-hidden border-0 shadow-lg" style="border-radius: .35rem .35rem 0 0;">
                    <div class="bg-wrapper"></div>
                    <div class="card-body p-0">
                        <!-- Nested Row within Card Body -->
                        <div class="row">
                            <div class="col-lg-7">
                                <div class="p-5">
                                    <div class="text-center">
                                        <img style="width: 100px;" src="../assets/logo.png" />
                                        <h3 class="font-alt">Cameroom</h3>
                                        <p class="text-muted mb-4 mt-3 font-alt">เรียกดูกล้องไอพีในบ้านหรือบริษัทของคุณในที่เดียว</p>
                                    </div>
                                    <h3 class="font-alt text-white text-center title-shadow">ดาวน์โหลดแอปพลิเคชั่น</h3> 
                                    <hr>
                                    <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center">
                                        <a class="me-lg-3 mb-4 mb-lg-0 text-center" href="https://play.google.com/store/apps/details?id=com.boonting.app.cameroom">
                                            <img class="app-badge" src="https://cameroom.net/assets/img/google-play-badge.svg" alt="...">
                                            <img class="app-badge" src="img/link_android.png" alt="android qr">
                                        </a>
                                        <a class="text-center" href="https://apps.apple.com/us/app/cameroom/id1588362608">
                                            <img class="app-badge" src="https://cameroom.net/assets/img/app-store-badge.svg" alt="...">
                                            <img class="app-badge" src="img/link_iOS.png" alt="iOS qr">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-5">
                                <div class="device-wrapper">
                                    <div class="device" data-device="iPhoneX" data-orientation="portrait" data-color="black">
                                        <div class="screen bg-black">
                                            <img src="img/app-1.png" style="max-width: 100%; height: 100%">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-get-started card o-hidden border-0 shadow-lg"  style="border-radius: 0 0 .35rem .35rem;">
                    <div class="bg-wrapper2"></div>
                    <div class="card-body p-0">
                        <div class="row">
                            <div class="col-lg-5">
                                <div class="device-wrapper2">
                                    <div class="device" data-device="MacPro" data-orientation="portrait" data-color="black">
                                        <div class="screen bg-black">
                                            <img src="img/app-2.png" style="max-width: 100%; height: 100%">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7">
                                <div class="container-fluid px-5">
                                    <div class="row gx-5">
                                        <div class="col-md-6 mb-2">
                                            <div class="text-center">
                                                <i class="bi-tv icon-feature text-gradient d-block mb-3"></i>
                                                <h3 class="font-alt">สร้างวอลรูมออนไลน์</h3>
                                                <p class="text-muted mb-0 font-alt">เรียกดูกล้องไอพีแบบหลายจอพร้อมกันแบบไม่จำกัดบนเว็บ เหมือนห้องมอนิเตอร์กล้องขนาดใหญ่</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-2">
                                            <div class="text-center">
                                                <i class="bi-phone icon-feature text-gradient d-block mb-3"></i>
                                                <h3 class="font-alt">เรียกดูผ่านสมาร์ทโฟน</h3>
                                                <p class="text-muted mb-0 font-alt">เรียกดูกล้องทั้งหมดของคุณผ่านสมาร์ทโฟนทั้งระบบ iOS และ Android</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 mb-2 mb-md-0">
                                            <div class="text-center">
                                                <i class="bi-share icon-feature text-gradient d-block mb-3"></i>
                                                <h3 class="font-alt">เชิญสมาชิกมาใช้งานร่วมกัน</h3>
                                                <p class="text-muted mb-0 font-alt">เชิญสมาชิกหรือพนักงานของคุณมาใช้งาน สามารถกำหนดสิทธิ์การมองเห็นกล้อง</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="text-center">
                                                <i class="bi-geo icon-feature text-gradient d-block mb-3"></i>
                                                <h3 class="font-alt">ดูตำแหน่งกล้องบนแผนที่</h3>
                                                <p class="text-muted mb-0 font-alt">ปักหมุดตำแหน่งของกล้อง แล้วเรียกดูในมุมมองแผนที่ จะซ่อมจะตรวจสอบ ให้แอปพาคุณไป</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>

            </div>

        </div>

      </TemplateLayout>
  </div>
</template>

<script>

import TemplateLayout from "@/components/layout/TemplateLayout.vue";

export default {
  name: 'Download',
  components: {
    TemplateLayout
  }
}

</script>

<style>
    @import 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css';
    @import 'https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,300;0,500;0,600;0,700;1,300;1,500;1,600;1,700&amp;display=swap';
    @import 'https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,300;0,500;0,600;0,700;1,300;1,500;1,600;1,700&amp;display=swap';
    @import 'https://fonts.googleapis.com/css2?family=Kanit:ital,wght@0,400;1,400&amp;display=swap';
    
    .app-badge{
        width: 200px;
        height: auto;
        object-fit: cover;
        margin-right: 1rem;
        margin-bottom: 1rem;
    }
    .section-get-started > .bg-wrapper {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-image: url(https://cameroom.net/assets/img/cctv.jpeg);
        background-size: cover;
        background-position: center;
        opacity: 0.2;
    }
    .section-get-started > .bg-wrapper2 {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-image: url(/park.jpg);
        background-size: cover;
        background-position: center;
        opacity: 0.2;
    }
    .device {
        position: relative;
        background-size: cover;
    }
    .device[data-device=iPhoneX][data-orientation=portrait][data-color=black] {
        padding-bottom: 198.898071625%;
    }
    .device::after {
        position: absolute;
        background-size: cover;
        width: 100%;
        height: 100%;
        pointer-events: none;
    }
    .device[data-device=iPhoneX][data-orientation=portrait][data-color=black]::after {
        content: "";
        background-image: url(https://cameroom.net/assets/img/portrait_black.png);
    }
    .bg-black {
        background-color: #000 !important;
    }
    .device .screen {
        position: absolute;
        background-size: cover;
        pointer-events: auto;
    }
    .device[data-device=iPhoneX][data-orientation=portrait][data-color=black] .screen {
        top: 3.1855955679%;
        left: 6.8870523416%;
        width: 86.2258953168%;
        height: 93.6288088643%;
    }
    .section-get-started .device-wrapper {
        max-width: 15rem;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 10%;
        margin-top: auto;
    }

    .device[data-device=MacPro][data-orientation=portrait][data-color=black] {
        padding-bottom: 65.898072%;
    }
    .device[data-device=MacPro][data-orientation=portrait][data-color=black]::after {
        content: "";
        background-image: url(/img/top-new-macbook.png);
    }
    .device[data-device=MacPro][data-orientation=portrait][data-color=black] .screen {
        top: 5.185596%;
        left: 13.957052%;
        width: 72.25895%;
        height: 69.628809%;
    }

    .section-get-started .device-wrapper2{
        max-width: 26rem;
        margin-left: auto;
        margin-right: auto;
        margin-top: 10%;
    }

    @media (min-width: 1200px) { 
        .section-get-started .device-wrapper {
            margin-top: 15%;
            margin-bottom: auto;
        }
        .section-get-started .device-wrapper2{
            margin-top: 26%;
        }
    }

    .text-gradient {
        background: -webkit-linear-gradient(#2937f0, #9f1ae2);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .icon-feature {
        font-size: 4rem;
    }
    .font-alt {
        font-family: "Kanit", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
        color: #212529;
    }
    .title-shadow{
        text-shadow: 1px 1px 2px black, 0 0 1em blue, 0 0 0.2em darkblue;
    }
</style>